import React from "react"
import './Wrapper.scss';

export default ({block = 'page', modifier = '', children, style = {}}) => {
  if (modifier) {
    modifier = ` ${block}__wrapper--${modifier}`;
  }
  return (<div className={`${block}__wrapper${modifier}`} style={style}>{children}</div>)
}